import { formatExchangeName } from '../../../../lineItemHelpers'

import { targetingTypes } from '../../../LineItemDv360Create/fields'
import { CUSTOM_EXCHANGES } from '../../../../UploadDV360AdCreative/UploadDV360AdCreativeForm/LineItemForm/fields'

export const getInitialValues = targeting => {
  const exchanges = targeting.filter(item => item.type === targetingTypes.TARGETING_TYPE_EXCHANGE)
  const formattedExchanges = exchanges
    // We show only exchanges that have a name
    .filter(exchange => exchange.exchange)
    .map(exchange => ({
      value: exchange.exchange,
      label: formatExchangeName(exchange.exchange)
    }))

  return {
    [CUSTOM_EXCHANGES]: formattedExchanges
  }
}
